import { Pipe, PipeTransform } from '@angular/core';
/*
 * Returns the Customer Name
 * Takes an object argument (Customer Info).
 *
 * Usage:
 *   customer | ivCustomerNameFn
 *
 * Example:
 *   {{ customer | ivCustomerNameFn:'%' }}
 *   formats to: Name1%Name2%Name3 etc...
*/
@Pipe({
  name: 'ivCustomerNameFn'
})
export class CustomerNameFnPipe implements PipeTransform {
  constructor() {
  }

  transform(customer: any, stringSeparator = ' ', maxLength = 120): string {
    const fullName = this.getCustomerName(customer, stringSeparator);
    return fullName.length > maxLength
      ? `${fullName.substring(0, maxLength)}...`
      : fullName;
  }

  getCustomerName(customer: any, separator: string = ' '): string {
    const customerName = [customer.name1 || '', customer.name2 || '', customer.name3 || ''];
    return customerName.filter(name => name !== '' && name !== ' ').join(separator);
  }
}
